/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ornate_Stout_Angelfish_DashInputs */

const fr_ornate_stout_angelfish_dash = /** @type {(inputs: Ornate_Stout_Angelfish_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le programme`)
};

/**

* @param {Ornate_Stout_Angelfish_DashInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const ornate_stout_angelfish_dash = /** @type {((inputs?: Ornate_Stout_Angelfish_DashInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ornate_Stout_Angelfish_DashInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_ornate_stout_angelfish_dash(inputs)
});